import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorkerRegistration'
import 'antd/dist/antd.css';
import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";
ReactDOM.render(
  
    <App />,
  document.getElementById('root')
);

serviceWorker.register();
